export const environment = {
  production: false,
  apiBaseUrl: 'https://gatewayapi-dev.clubdeportivomunicipal.pe',
  userFrontendUrl: 'https://dev.clubdeportivomunicipal.pe',
};
